<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="employeeFingerFormEdit"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ employee.firstname_th }} {{ employee.lastname_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ employee.employee_code }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <p>
          {{ biometric.title_th || 'ลายนิ้วมือ' }}
        </p>
        <v-card class="mt-3 pa-2 d-flex justify-space-between" outlined>
          <div class="d-flex align-center">
            <v-list-item-avatar size="56" class="ma-0 pa-0">
              <v-icon x-large>mdi-fingerprint</v-icon>
            </v-list-item-avatar>
            <div class="ml-2">
              <div>
                {{ biometricSelected.title_th }}
              </div>
              <div>
                <span style="font-size: 12px" class="gray--text"
                  >อัพเดตเมื่อ
                  {{
                    biometricSelected?.employee_biometric?.last_updated
                      | formatDate
                  }}</span
                >
              </div>
            </div>
          </div>
        </v-card>
        <div class="mt-5">
          <div>
            <label class="body-2">
              ประเภทไฟล์ลายนิ้วมือ
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-select
              v-model="selectFileType"
              class="fix-google-chrome mt-1"
              :items="[
                { text: '.TPL', value: '.tpl' },
                { text: '.DAT', value: '.dat' },
              ]"
              :rules="[(v) => !!v || 'โปรดระบุประเภทไฟล์']"
              item-text="text"
              item-value="value"
              outlined
              dense
            ></v-select>
          </div>

          <div v-if="selectFileType === '.tpl'">
            <label class="body-2">
              ลายนิ้วมือ Template
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-file-input
              class="fix-google-chrome mt-1"
              v-model="fileTpl"
              ref="fingerFileInputTpl"
              :rules="rulesTpl"
              accept=".tpl"
              show-size
              @change="onFileChangeTpl"
              @click:clear="onFileClearTpl"
              outlined
              dense
              placeholder="เลือกไฟล์ .TPL"
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
              "
            >
            </v-file-input>
          </div>

          <div v-else>
            <label class="body-2">
              ลายนิ้วมือ Template
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-file-input
              class="fix-google-chrome mt-1"
              v-model="fileDat"
              ref="fingerFileInputDat"
              :rules="rulesDat"
              accept=".dat"
              show-size
              @change="onFileChangeDat"
              @click:clear="onFileClearDat"
              outlined
              dense
              placeholder="เลือกไฟล์ .DAT"
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
              "
            >
            </v-file-input>
          </div>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center" v-if="!isDataChange">
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::biometric:update_delete')
            "
            icon
            @click="handleDeleteEmployeeFinger"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row v-else justify="center" align="center">
          <v-btn
            class="primary mr-3"
            depressed
            @click="handleEmployeeFingerFormEdit"
            >ตกลง</v-btn
          >
          <v-btn depressed @click="handleCancel">ยกเลิก</v-btn>
        </v-row>
        <div class="d-sr-only">{{ isDataChange }}</div>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
  </v-navigation-drawer>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import moment from 'moment'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      required: true,
    },
    employee: {
      type: Object,
      required: true,
    },
    biometric: {
      type: Object,
      required: true,
    },
    biometricSelected: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectFileType: '.dat',
      selectFileTypeInit: '.dat',
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      rulesTpl: [
        (v) => !!v || 'จำเป็นต้องเลือกไฟล์',
        (v) =>
          !v ||
          v.name.split('.').pop().toLowerCase() === 'tpl' ||
          'ไฟล์ต้องเป็น .tpl เท่านั้น',
      ],
      rulesDat: [
        (v) => !!v || 'จำเป็นต้องเลือกไฟล์',
        (v) =>
          !v ||
          v.name.split('.').pop().toLowerCase() === 'dat' ||
          'ไฟล์ต้องเป็น .dat เท่านั้น',
      ],
      fileTpl: null,
      fileDat: null,
    }
  },

  watch: {
    biometricSelected(value) {
      const fileType = value?.employee_biometric?.file_ext.toLowerCase()
      this.selectFileType = fileType
      this.selectFileTypeInit = fileType
    },
  },

  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isDataChange() {
      if (
        this.selectFileType !== this.selectFileTypeInit ||
        this.fileTpl ||
        this.fileDat
      ) {
        this.$emit('isEmployeeFingerFormDataChange', true)
        return true
      } else {
        this.$emit('isEmployeeFingerFormDataChange', false)
        return false
      }
    },
    employeeBiometric() {
      return this.$store.state.employee.employeeBiometric
    },
  },

  filters: {
    formatDate: function (value) {
      return moment(value).format('DD/MM/YYYY')
    },
  },

  methods: {
    handleClickBack() {
      if (this.isDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs?.fingerFileInputDat?.reset()
        this.$refs?.fingerFileInputTpl?.reset()
        this.fileDat = null
        this.fileTpl = null

        this.$refs?.employeeFingerFormEdit?.reset()
        this.$emit('onClickBack')
      }
    },

    async onFileChangeTpl(fileTpl) {
      if (fileTpl && this.$refs.fingerFileInputTpl.validate()) {
        this.fileTpl = fileTpl
      }
    },

    async onFileChangeDat(fileDat) {
      if (fileDat && this.$refs.fingerFileInputDat.validate()) {
        this.fileDat = fileDat
      }
    },

    onFileClearTpl() {
      this.fileTpl = null
    },

    onFileClearDat() {
      this.fileDat = null
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },

    handleCancel() {
      this.$refs?.fingerFileInputDat?.reset()
      this.$refs?.fingerFileInputTpl?.reset()
      this.fileDat = null
      this.fileTpl = null

      this.$refs?.employeeFingerFormEdit?.reset()
      this.$emit('onClickBack')
    },

    handleDeleteEmployeeFinger() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ',
        value: `${this.biometricSelected.title_th}`,
        item: this.biometricSelected,
      }
    },

    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },

    submitConfirmDialogDelete(biometric) {
      const employeeBio = this.employeeBiometric.find(
        (e) => e.biometric_code === this.biometric.biometric_code
      )

      if (employeeBio) {
        employeeBio.biometric_property = employeeBio.biometric_property.filter(
          (biometricProp) =>
            biometricProp.biometric_property_code !==
            biometric.biometric_property_code
        )
      }

      this.confirmDialogDelete = false

      this.$refs?.fingerFileInputDat?.reset()
      this.$refs?.fingerFileInputTpl?.reset()
      this.fileDat = null
      this.fileTpl = null

      this.$refs?.employeeFingerFormEdit?.reset()
      this.$emit('onClickBack')
    },

    async handleEmployeeFingerFormEdit() {
      const fileKey =
        this.selectFileType === '.dat'
          ? 'fingerFileInputDat'
          : 'fingerFileInputTpl'

      if (
        this.$refs.employeeFingerFormEdit.validate() &&
        this.$refs[fileKey].validate()
      ) {
        try {
          let file_base64 = null
          let file_ext = null
          let file_size_byte = null
          if (this.fileTpl) {
            file_base64 = await this.getBase64(this.fileTpl)
            file_base64 = file_base64.split(',').pop()
            file_ext = this.fileTpl.name.split('.').pop()
            file_size_byte = this.fileTpl.size
          }
          if (this.fileDat) {
            file_base64 = await this.getBase64(this.fileDat)
            file_base64 = file_base64.split(',').pop()
            file_ext = this.fileDat.name.split('.').pop()
            file_size_byte = this.fileDat.size
          }

          let biometricProperty = []

          if (this.selectFileType === '.dat') {
            biometricProperty = this.biometric.biometric_property.map(
              (item) => ({
                ...item,
                employee_biometric: {
                  biometric_property_code: item.biometric_property_code,
                  file_base64_legacy: this.fileDat ? file_base64 : undefined,
                  file_base64: this.fileDat ? undefined : file_base64,
                  file_ext: `.${file_ext}`,
                  file_size_byte,
                },
              })
            )
          } else {
            biometricProperty = this.biometric.biometric_property
              .filter(
                (item) =>
                  item.biometric_property_code ===
                  this.biometricSelected.biometric_property_code
              )
              .map((item) => ({
                ...item,
                employee_biometric: {
                  biometric_property_code: item.biometric_property_code,
                  file_base64_legacy: this.fileDat ? file_base64 : undefined,
                  file_base64: this.fileDat ? undefined : file_base64,
                  file_ext: `.${file_ext}`,
                  file_size_byte,
                },
              }))
          }

          const employeeBio = this.employeeBiometric.find(
            (e) => e.biometric_code === this.biometric.biometric_code
          )

          if (employeeBio) {
            if (this.selectFileType === '.tpl') {
              const index = employeeBio.biometric_property.findIndex(
                (eb) =>
                  eb.biometric_property_code === this.biometric.biometric_code
              )

              if (index !== -1) {
                employeeBio.biometric_property.splice(index, 1)
              }
            } else {
              employeeBio.biometric_property = []
            }
          }

          const fingerData = {
            biometric_code: this.biometric.biometric_code,
            biometric_property: employeeBio
              ? [...employeeBio.biometric_property, ...biometricProperty]
              : [...biometricProperty],
            title_th: this.biometric.title_th,
            title_en: this.biometric.title_en,
          }

          this.$refs?.fingerFileInputDat?.reset()
          this.$refs?.fingerFileInputTpl?.reset()
          this.fileDat = null
          this.fileTpl = null

          this.$refs?.employeeFingerFormEdit?.reset()
          this.$emit('submitEmployeeFingerFormEdit', fingerData)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs?.fingerFileInputDat?.reset()
      this.$refs?.fingerFileInputTpl?.reset()
      this.fileDat = null
      this.fileTpl = null

      this.$refs?.employeeFingerFormEdit?.reset()
      this.$emit('onClickBack')
    },
  },
}
</script>
